module.exports = __webpack_public_path__ + "static/food3-d2c97c554933ddbffe902c31d299fa53.jpg";